import { render, staticRenderFns } from "./eb-skeleton.vue?vue&type=template&id=08843202&"
import script from "./eb-skeleton.vue?vue&type=script&lang=js&"
export * from "./eb-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports